import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators , FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { ElementRef, Renderer2 } from '@angular/core';
import Swal from 'sweetalert2'

declare let gtag: Function;

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css']
})

export class FormularioComponent implements OnInit {
  forma: FormGroup;
  rut: string;
  nombre: string;
  noarchivo=false;
  notipopdf=false;
  apellidop: string;
  apellidom: string;
  persona: string;
  correo:string; 
  correo2:string;
  consultor:string;
  result:any;
  result2:any;
  alerta=false;
  archivo: any;
  estetexto : string ;
  code:string;
  state:string;
  tipocuenta:string;
  region:string;
  fecha:string;
  banco:string;
  tiposolicitud:string;
  documento:any;
  doc2:any;
  mostrar=false;

  //private urlservupload:string = environment.supload;
  cuenta:string;
  //private urlinsert:string = environment.insert;

  ngOnInit(): void {
  }

  constructor( private http: HttpClient,private fb: FormBuilder,private router: Router, private googleAnalyticsService:GoogleAnalyticsService,el: ElementRef, renderer: Renderer2 ) {
    /* 
    if (location.protocol !== "https:") {
      location.protocol = "https";
      location.reload();
    } */
  
    var events = 'cut copy paste';
    events.split(' ').forEach(e => 
    renderer.listen(el.nativeElement, e, (event) => {
      event.preventDefault();
      })
    );
    //this.trackMe();

    if ( (this.code == null || this.code == 'undefined') && localStorage.getItem('code') != null ) { 
      this.code = localStorage.getItem('code');
    }
 
    if ( (this.state == null || this.state == 'undefined') && localStorage.getItem('state') != null ) { 
      this.state = localStorage.getItem('state');
    }
    //
    let httpost = this.http;
    //console.log(urltoken);
 
     
    if ( (this.rut == null || this.rut == '0') && (localStorage.getItem('rut') != null )) this.rut = localStorage.getItem('rut');
    if ( (this.nombre == null || this.nombre=='')  && (localStorage.getItem('nombre') != null )) this.nombre = localStorage.getItem('nombre'); 
    if ( (this.apellidop == null || this.apellidop == '') && (localStorage.getItem('apellidop') != null ) ) this.apellidop = localStorage.getItem('apellidop');
    if ( (this.apellidom == null || this.apellidom == '') && (localStorage.getItem('apellidom') != null ) ) this.apellidom = localStorage.getItem('apellidom');
   
    //
 
    this.crearFormulario();
    this.cargardatosIni();
  }

  get rutNoValido() {
    return this.forma.get('rut').invalid && this.forma.get('rut').touched
  }
  get correoNoValido() {
    return this.forma.get('correo').invalid && this.forma.get('correo').touched
  }
  get correo2NoValido() {
    return this.forma.get('correo2').invalid && this.forma.get('correo2').touched
  }
  
  get cuentaNoValida() {
    return this.forma.get('cuenta').invalid && this.forma.get('cuenta').touched
  }
  
  crearFormulario() {
   
    this.forma = this.fb.group({
      rut  : ['', [Validators.required ,Validators.pattern('[0-9]{8}')]] ,
      correo  : ['', [ Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')] ],
      correo2  : ['', [ Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')] ],  doc   : ['', Validators.required ],
      //Consultor   : ['', Validators.required ],
      cuenta   : ['', Validators.required ],
      region: ['', Validators.required ] ,
    
      tipocuenta: ['', Validators.required ],
      banco: ['', Validators.required ] ,
      doc2: ['', Validators.required ] ,
      documento: ['', Validators.required ] ,
      tiposolicitud: ['', Validators.required ] 
    });
  
  } // fin crea formulario
  
  cargardatosIni(){
    this.forma.setValue( {
      rut : '',
      correo:'',
      correo2:'',
      documento:'',
      doc2:'',
      doc:'',
      banco:'',
      cuenta:'',
      region:'',
      tipocuenta:'',
      tiposolicitud:'1'
    })
   
  }// fin de carga datos ini
  
  file:any;
  archivob64: string;
  file2:any;
  archivob642: string;
    
  public fileChanged(e) {
    this.file = e.target.files[0];
    this.documento=this.file;
  };

  public fileCambio(e) {
    this.file2 = e.target.files[0];
    this.doc2=this.file2;
  };

  public onBancoChange(f){
    this.banco= f.target.value;
  }

  public onSolChange(g){
    this.tiposolicitud = g.target.value;
  }

  public onRegionChange(h) {
    //TO DO ...
    this.region= h.target.value;
  }

  public onTipoCuenta(entrada) {
    //TO DO ...
    this.tipocuenta= entrada.target.value;
  }
  
  
  guardar() {
    
    var  resultado:any;
    this.correo=this.forma.get('correo').value;
    this.persona=this.forma.get('rut').value;
    this.correo2=this.forma.get('correo2').value;
    this.correo=this.forma.get('correo').value;
    this.cuenta= this.forma.get('cuenta').value;  
    // this.trackMe;
    // base 64
  
    var reader = new FileReader();
    var reader2= new FileReader();
    var ruti = this.persona;
    var archivo1= this.file;
    var archivo2= this.file2;
    var estetexto :string;
    var texto: string;
    let numerorut:any;
    let cincuenta:number;
    numerorut = parseInt(this.persona,10);
    cincuenta = 50000000;
    let httpost = this.http;
    
    //let urlinsert = `${ this.urlinsert}`;
    //let urlservupload = `${ this.urlservupload}`;
    
    //
    if ( (this.rut == null || this.rut == '0') && ( localStorage.getItem('rut') != null && localStorage.getItem('rut') != '0' )){ 
      this.rut = localStorage.getItem('rut');
    };
  
    // insertar
  
    /*httpost.post<any>(urlinsert, { 
      rut_empresa:this.persona,
      rut_representante:this.rut,
      correo1:this.correo,
      correo2:this.correo2,
      cuenta:this.cuenta,
      tipo_cuenta:this.tipocuenta,
      region:this.region,
      fecha: '01-01-2021',
      banco: this.banco,
      estado:'0',
      tipo_solicitud:this.tiposolicitud
  
    }).subscribe((reg:any) => {
      this.result = reg.Resultado;
      // console.log (this.result);
      if (numerorut < cincuenta){
        this.mostrar=true;
        this.alerta=true;
      };
    }, err => {
      console.log("error insertar");
    });*/
  
    // Para cargar documentos , para aquellos rut > 50.000.000  
  
    if( (this.file == null ) || (this.file2 == null )  ) {
      this.noarchivo=true;
    }else{
      this.noarchivo= false;
      if ((this.file.type!= "application/pdf") ||(this.file2.type!= "application/pdf")){
        this.notipopdf=true;
      }else{
        this.notipopdf= false;
      };
    };
  
    if (numerorut >= cincuenta ){
      //Proveedores e ingresa en validaciones. Debe obligatoriamente ingresar archivo y éste debe ser pdf
      if ((this.noarchivo==true)|| (this.notipopdf==true)){
        if (this.noarchivo==true ) { 
          this.alerta=false;
          this.mostrar=false;
          Swal.fire('', 'Por favor adjunte archivo', 'error');
        };

        if (this.notipopdf==true){ 
          this.alerta=false;
          this.mostrar=false;
            Swal.fire('', 'Por favor adjunte archivo PDF', 'error'); 
        };

        this.mostrar=false;
        this.alerta=false;
      }else{
        // Si no tiene nada de error puedo grabar
        if (( this.file != null) && (this.file2 != null)) {
          reader.readAsDataURL(this.file);
          reader2.readAsDataURL(this.file2);
        
          reader.onload =function () { // funcion1
            texto = reader.result.toString();
            texto =texto.replace('data:application/pdf;base64,','');
            reader2.onload = function (){
              estetexto=reader2.result.toString();
              estetexto =estetexto.replace('data:application/pdf;base64,','');
              //  Servicio para almacenar en alfresco
              /*httpost.post<any>(urlservupload, { 
                rut1: ruti,
                rut2: localStorage.getItem('rut') ,
                mimeType1:"application/pdf", 
                fileName1:archivo1.name, 
                fileName2: archivo2.name,
                archivo1:texto,
                archivo2:estetexto
              }).subscribe((resp:any) => {
                resultado=resp.resultado;
                // console.log(resp.resultado);
                
              }, err => {
                console.log("error upload");
              });*/
            };  
          }; // termina funcion 1  
          this.mostrar=true;
          this.alerta=true;
        };// fin validación
      };
    }; // numerorut >= cincuenta termina esto
  }// fin de guardar
  
  verInicio(){
    localStorage.clear();
    this.router.navigate(['/inicio']);
  }
  
  cerrar(){
    localStorage.clear();
    this.router.navigate(['/inicio']);
  }
  
  trackMe() {
    this.googleAnalyticsService
    .eventEmitter('Fin de la solicitud', 'Trámite digital', 'Trámite - 1000830000', '0');
  } // fin de trackMe

}
